import { Alert, Slide, Snackbar } from '@mui/material';
import { useEffect, useState } from 'react';
import 'src/muiLicense';
import { useAppSelector } from 'src/store';

/**
 * App Container which load the Etmf component
 *
 * @returns ThemeProvider of Etmf App component.
 */
export default function SnackbarComponent() {
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
  const [snackbarStatus, setSnackbarStatus] = useState('hidden');
  const { message, severity, timestamp, vertical, horizontal } = useAppSelector(state => state.settings.snackbar);

  useEffect(() => {
    message && setIsSnackbarOpen(true);
    if(message === '') {
      setSnackbarStatus('hidden');
    } else {
      setSnackbarStatus('shown');
    }
  }, [message, timestamp]);
  return (
    <Snackbar
      open={isSnackbarOpen}
      className={snackbarStatus}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      autoHideDuration={5000}
      TransitionComponent={props => <Slide {...props} direction="right" />}
      onClose={(_event, reason) => {
        if (reason === 'timeout') {
          setIsSnackbarOpen(false);
          setSnackbarStatus('hidden');
        }
      }}
    >
      <Alert severity={severity}>{message}</Alert>
    </Snackbar>
  );
}
